import BrioLogoFooter from "../../../../app/sidebar/BrioLogoFooter";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import moment from "moment/moment";
import {
   getTestIdByTestTypeId,
    getTestNameByTypeId,
    TEST_TYPES,
    TestType
} from "../../../../shared/types/testTypes";
import Chip from "@mui/material/Chip";
import Icon from "../../../../shared/ui/Icon";
import {NavLinkStyled} from "../../../../app/sidebar/Menu";
import {useCallback, useMemo} from "react";
import BoxContent from "../../../../shared/ui/BoxContent";
import {Stack} from "@mui/material";
import {getLevelColor} from "../utils/functions";
import {useLocation} from "react-router-dom";
import {TestHistory} from "../../../tests/listing/components/_interfaces";
import {useAuth} from "../../../../hooks/useAuth";
import useIsLoggedIn from "../../../../hooks/useIsLoggedIn";

interface IAnswersHeaderProps {
    locationUrl: string;
    reportId: string;
    score?: number;
    testDate: string;
    testTypeId: number;
    subjectName: string;
    className?: string;
    isArchived?: boolean;
}

interface NavItem {
    label: string;
    to: (reportId: string) => string;
    icon: string;
    value: string;
}

const REPORT_NAV_ITEMS: NavItem[] = [
    {
        label: "Raport",
        to: (id) => `/teste/raport/${id}`,
        icon: "far chart-line-up",
        value: "raport",
    },
    {
        label: "Răspunsuri",
        to: (id) => `/teste/raspunsuri/${id}`,
        icon: "far list-check",
        value: "raspunsuri",
    },
    {
        label: "Raport Activitate",
        to: (id) => `/teste/log/${id}`,
        icon: "fas camera-cctv",
        value: "log",
    },
];

const REPORT_NAV_ITEMS_SIMPLE: NavItem[] = [
    {
        label: "Răspunsuri",
        to: (id) => `/teste/raspunsuri/${id}`,
        icon: "far list-check",
        value: "raspunsuri",
    },
    {
        label: "Raport Activitate",
        to: (id) => `/teste/log/${id}`,
        icon: "fas camera-cctv",
        value: "log",
    },
];

const isScoreHiddenForTestType = (typeId: number): boolean => [2, 7].includes(typeId);

const isStandaloneClassTest = (typeId: number): boolean => [3, 4].includes(typeId);

const formatSubjectGrade = (testTypeId: number, subjectName?: string, className?: string): string => {
    if (isStandaloneClassTest(testTypeId)) {
        return className || "";
    }
    const name = subjectName || getTestNameByTypeId(testTypeId);
    return className ? `${name} · clasa ${className}` : name;
};

const ReportHeader = ({
                           locationUrl,
                           reportId,
                           score,
                           testDate,
                           testTypeId,
                           subjectName,
                           className,
                           isArchived = false,
}: IAnswersHeaderProps) => {
    const {user} = useAuth();
    const type: TestType | undefined = getTestIdByTestTypeId(testTypeId);
    const isLoggedIn = useIsLoggedIn();

    console.log(isLoggedIn)

    const testConfig = type ? TEST_TYPES[type] : TEST_TYPES["school"];

    const canViewReport =
            testConfig.canShowReport &&
            !(
                testTypeId === 1 &&
                user.testsListingShow !== undefined &&
                !user.testsListingShow
            );

    const title = useMemo(
        () => formatSubjectGrade(testTypeId, subjectName, className),
        [testTypeId, subjectName, className]
    );

    const formattedDate = useMemo(() => {
        if (!testDate) return "";
        return moment(testDate).locale("ro").format("DD.MM.YYYY");
    }, [testDate]);

    const shouldShowScore =
        locationUrl === "raspunsuri" &&
        !isScoreHiddenForTestType(testTypeId) &&
        score !== null &&
        score !== undefined;

    const gradeName = testTypeId === 5 || testTypeId === 6 || testTypeId === 8 || testTypeId === 9 ? "Scor" : "Notă";

    const shouldShowReport = locationUrl !== "previzualizare" && canViewReport;

    const isStudent = user.position === "student";

    const navItems = useMemo(() => {
        const items = shouldShowReport ? REPORT_NAV_ITEMS : REPORT_NAV_ITEMS_SIMPLE;
        if (isStudent) {
            return items.filter((item) => item.value !== "log");
        }
        return items;
    }, [shouldShowReport, isStudent]);

    return (
        <BoxContent color="light">
            <Stack
                width="100%"
                direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "flex-start", md: "center" }}
                justifyContent="space-between"
                spacing={2}
                sx={{ mb: 1 }}
            >
                <Stack direction={{xs: "column", sm: "row"}} alignItems="center" spacing={2.5}>
                    <BrioLogoFooter size="small" imageSize={40}/>
                    <Box sx={{
                        ml: {xs: 0, md: 2},
                        my: {xs: 1, md: 0},
                    }}
                    >
                        <Typography variant="h2">{title}</Typography>
                        {(locationUrl === "raspunsuri" && formattedDate) ? (
                            <Typography variant="body1">{formattedDate}</Typography>
                        ) : (
                            <Typography variant="body1">{testDate}</Typography>
                        )}
                    </Box>
                </Stack>
                <Stack direction="column" alignItems={{xs: "flex-start", md:"flex-end", }}>
                    <Box>
                        {shouldShowScore && <Chip
                            label={`${gradeName} ${parseFloat(Number(score).toFixed(2))}`}
                            size="medium"
                            variant="outlined"
                            sx={{mr: 1, my: 1,color: getLevelColor(score, true), borderColor: getLevelColor(score, false)}}
                        />}

                        <Chip
                            label={locationUrl === "rapoarte-clasa" ? `Id #${reportId}` : `Sesiunea #${reportId}`}
                            size="medium"
                            color="primary"
                            variant="outlined"
                            sx={{mr: 1, my: 1 }}
                        />
                    </Box>
                    { (locationUrl === "raspunsuri" || locationUrl === "log") && !isArchived && isLoggedIn && (
                        <Stack direction={{xs: "column", sm: "row"}} justifyContent="flex-end" whiteSpace="nowrap" mt={1}>
                            {navItems.map((item) => (
                                <NavLinkStyled to={item.to(reportId)} key={item.label}>
                                    <Box component="span" display="inline-flex" alignItems="center" py={0.5}>
                                        <Box
                                            component="span"
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginRight: {xs: 0.5, lg: 1, xl: 1.5},
                                            }}
                                        >
                                            <Icon icon={item.icon} fixedWidth/>
                                        </Box>
                                        <Box component="span" flexGrow={1}>
                                            <Typography variant="body1">{item.label}</Typography>
                                        </Box>
                                    </Box>
                                </NavLinkStyled>
                            ))}
                        </Stack>
                    )}
                </Stack>
            </Stack>

        </BoxContent>
    )
}

export default ReportHeader;